<div class="optimize-book-tabs-section">
    <div class="each-optimize-book-tab" [ngClass]="{ 'each-optimize-book-tab-selected': selected_optimize_book_tab == 'By Date' }" (click)="selected_optimize_book_tab = 'By Date'; getPageData();" >
        <div class="each-to-do-heading-section">
            <img src="assets/action-items.png" class="each-to-do-icon" />
            <span>For - {{ to_do_date | date: "d MMM" }} </span>
            <!-- <span class="current-date-section">For - {{to_do_date | date: 'd MMM'}}</span> -->
            <input type="text" #to_do_picker="bsDatepicker" bsDatepicker [(ngModel)]="to_do_date" style="visibility: hidden; width: 0" (ngModelChange)="getPageData()" />
            <img src="assets/calendar.png" class="calendar-icon" (click)="to_do_picker.toggle()" *ngIf="selected_optimize_book_tab == 'By Date'" />
            <img src="assets/calendar.png" class="calendar-icon" *ngIf="selected_optimize_book_tab != 'By Date'" style="cursor: default" />
        </div>
    </div>
    <div class="each-optimize-book-tab" [ngClass]="{ 'each-optimize-book-tab-selected': selected_optimize_book_tab == 'Notifications' }" (click)="selected_optimize_book_tab = 'Notifications'; getPageData();" >
        <div class="each-to-do-heading-section">
            <img src="assets/notifications.png" class="each-to-do-icon" />
            <span>Notifications</span>
        </div>
    </div>
</div>
<!-- <div *ngIf="selected_optimize_book_tab == 'By Date'"> -->
<div>
    <div class="to-do-section">
        <div class="each-to-do-section">
            <div class="to-do-filter-section">
                <div class="to-do-filter-input-section">
                    <p class="to-do-filter-input-label">Importance</p>
                    <mat-select class="to-do-filter-input" [(ngModel)]="importance_filter" (selectionChange)="getPageData()">
                        <mat-option [value]="'All'">All</mat-option>
                        <mat-option [value]="'Low'">Low</mat-option>
                        <mat-option [value]="'Medium'">Medium</mat-option>
                        <mat-option [value]="'High'">High</mat-option>
                    </mat-select>
                </div>
                <div class="to-do-filter-input-section" *ngIf="user_role == 'Advisor Manager'">
                    <p class="to-do-filter-input-label">Activity Stage</p>
                    <mat-select class="to-do-filter-input" [(ngModel)]="stage_filter" (selectionChange)="getPageData()">
                        <mat-option [value]="'All'">All</mat-option>
                        <mat-option [value]="1">General</mat-option>
                        <mat-option [value]="3">Coaching Plan</mat-option>
                        <mat-option [value]="4">Coaching Plan Follow Up</mat-option>
                        <mat-option [value]="2">Advisor Attrition</mat-option>
                    </mat-select>
                </div>
				<div class="to-do-filter-input-section" *ngIf="user_role != 'Advisor Manager'">
					<p class="to-do-filter-input-label">Activity Stage</p>
					<mat-select class="to-do-filter-input" [(ngModel)]="stage_filter" (selectionChange)="getPageData()">
						<mat-option [value]="'All'">All</mat-option>
						<!-- <mat-option [value]="'Pitch(Sales)'">Pitch(Sales)</mat-option>
						<mat-option [value]="'Follow Up(Sales)'">Follow Up(Sales)</mat-option>
						<mat-option [value]="'Pitch(Retention)'">Pitch(Retention)</mat-option>
						<mat-option [value]="'Follow Up(Retention)'">Follow Up(Retention)</mat-option> -->
                        <mat-option class="capitalize" *ngFor="let stage of stages_list" [value]="stage.id">{{stage.name}} ({{stage.type}})</mat-option>
					</mat-select>
				</div>
                <div class="to-do-filter-input-section" *ngIf="user_role != 'Advisor Manager'">
					<p class="to-do-filter-input-label">Client Stage</p>
					<mat-select class="to-do-filter-input" [(ngModel)]="client_stage_filter" (selectionChange)="getPageData()">
						<mat-option [value]="'All'">All</mat-option>
						<!-- <mat-option [value]="'Pitch(Sales)'">Pitch(Sales)</mat-option>
						<mat-option [value]="'Follow Up(Sales)'">Follow Up(Sales)</mat-option>
						<mat-option [value]="'Pitch(Retention)'">Pitch(Retention)</mat-option>
						<mat-option [value]="'Follow Up(Retention)'">Follow Up(Retention)</mat-option> -->
                        <mat-option class="capitalize" *ngFor="let stage of stages_list" [value]="stage.id">{{stage.name}} ({{stage.type}})</mat-option>
					</mat-select>
				</div>
                <div class="to-do-filter-input-section">
                    <p class="to-do-filter-input-label">Status</p>
                    <mat-select class="to-do-filter-input" [(ngModel)]="status_filter" (selectionChange)="getPageData()">
                        <mat-option [value]="'All'">All</mat-option>
                        <mat-option *ngFor="let status of status_list" [value]="status.id" >{{ status.name }}</mat-option>
                    </mat-select>
                </div>
				<div class="to-do-filter-input-section" *ngIf="user_role == 'Advisor'">
					<p class="to-do-filter-input-label">Assigned Assistant</p>
					<mat-select class="to-do-filter-input" [(ngModel)]="afa_filter" (selectionChange)="getPageData()">
						<mat-option [value]="'All'">All</mat-option>
						<mat-option [value]="'Yes'">Yes</mat-option>
						<mat-option [value]="'No'">No</mat-option>
					</mat-select>
				</div>
				<div class="to-do-filter-input-section" *ngIf="notification_item_selected == 'completed task'">
					<p class="to-do-filter-input-label">Duration</p>
					<mat-select class="to-do-filter-input" [(ngModel)]="duration_filter" (selectionChange)="getPageData()">
						<mat-option [value]="'last 1 month'">Last 1 Month</mat-option>
						<mat-option [value]="'last 3 months'">Last 3 Months</mat-option>
						<mat-option [value]="'last 6 months'">Last 6 Months</mat-option>
						<mat-option [value]="'last 1 year'">Last 1 Year</mat-option>
						<mat-option [value]="'last 3 years'">Last 3 Years</mat-option>
						<mat-option [value]="'last 5 years'">Last 5 Years</mat-option>
					</mat-select>
				</div>
				<div class="to-do-filter-input-section" *ngIf="notification_item_selected == 'completed task'">
					<p class="to-do-filter-input-label" *ngIf="user_role == 'Advisor Manager'">Advisor Name</p>
					<p class="to-do-filter-input-label" *ngIf="user_role != 'Advisor Manager'">Client Name</p>
					<input
						type="text"
						placeholder="Search..."
						class="to-do-filter-input"
						[(ngModel)]="search_filter"
						(keydown.enter)="getPageData()"
					/>
				</div>
            </div>
            <div class="each-to-do-content-section">
                <div class="to-do-tabs-section" *ngIf="selected_optimize_book_tab == 'By Date'">
                    <span class="to-do-tab" [ngClass]="{ 'to-do-tab-selected': action_item_selected == 'email' }" (click)="action_item_selected = 'email'; segregateData();" >Email Follow-ups</span>
                    <span class="to-do-tab" [ngClass]="{ 'to-do-tab-selected': action_item_selected == 'meeting' }" (click)="action_item_selected = 'meeting'; segregateData();" >F2F Meetings</span>
                    <span class="to-do-tab" [ngClass]="{ 'to-do-tab-selected': action_item_selected == 'call' }" (click)="action_item_selected = 'call'; segregateData();" >Calls</span>
                    <span class="to-do-tab" [ngClass]="{ 'to-do-tab-selected': action_item_selected == 'conference' }" (click)="action_item_selected = 'conference'; segregateData();" >Conferences</span>
                    <span class="to-do-tab" [ngClass]="{ 'to-do-tab-selected': action_item_selected == 'virtual meeting' }" (click)=" action_item_selected = 'virtual meeting'; segregateData(); " >Virtual Meeting</span>
                    <span class="to-do-tab" [ngClass]="{ 'to-do-tab-selected': action_item_selected == 'other' }" (click)="action_item_selected = 'other'; segregateData();" >Other</span>
                </div>
				<div class="to-do-tabs-section" *ngIf="selected_optimize_book_tab == 'Notifications'">
					<span class="to-do-tab" [ngClass]="{ 'to-do-tab-selected': notification_item_selected == 'pending task' }" (click)="notification_item_selected = 'pending task'; segregateData();" >Pending Tasks</span>
					<span class="to-do-tab" [ngClass]="{ 'to-do-tab-selected': notification_item_selected == 'upcoming task' }" (click)="notification_item_selected = 'upcoming task'; segregateData();" >Upcoming Tasks</span>
					<span class="to-do-tab" [ngClass]="{ 'to-do-tab-selected': notification_item_selected == 'completed task' }" (click)="notification_item_selected = 'completed task'; segregateData();" >Completed Tasks</span>
					<span class="to-do-tab" [ngClass]="{ 'to-do-tab-selected': notification_item_selected == 'internal notification' }" (click)="notification_item_selected = 'internal notification'; segregateData();" >Internal Notifications</span>
				</div>
				<ng-container *ngIf="page_data_loaded">
					<ng-container *ngIf="notification_item_selected != 'internal notification'">
						<div class="activities-section">
							<ng-container *ngTemplateOutlet="activitiesSection;"></ng-container>
						</div>
					</ng-container>
					<ng-container *ngIf="notification_item_selected == 'internal notification'">
						<div class="each-to-tab-content-section" *ngIf="activities.length > 0">
							<div class="each-to-do-detail-section" *ngFor="let todo of activities">
								<div class="each-to-do-detail-content-section">
									<img src="assets/internal-notification.png" class="to-do-detail-image" />
									<span>{{ todo.title }}</span>
								</div>
							</div>
						</div>
						<div class="to-do-zero-state" *ngIf="activities.length == 0">
							<span>No Internal Notifications Found</span>
						</div>
					</ng-container>
				</ng-container>
			</div>
		</div>
	</div>
</div>
<ng-container *ngIf="!page_data_loaded">
    <app-loader [loading_text]="'Loading Action Items'"></app-loader>
</ng-container>
<!-- <div *ngIf="selected_optimize_book_tab == 'Notifications'">

</div> -->

<ng-template #activitiesSection>
    <div class="automated-activities-section">
        <!-- <div class="automated-activities-header-section">
            <div class="automated-activities-heading-section">
                <img src="assets/automated-activities.png" class="automated-activities-heading-icon" />
                <span>Activities</span>
            </div>
        </div> -->
        <div class="automated-activities-content-section">
            <ng-container *ngIf="!activities_loader">
                <!-- <div class="activities-button-section" *ngIf="selected_activities.length > 0">
                    <button class="page-modal-primary-button" (click)="openAutomatedActivityOperationModal(selected_activities, '')">Stop Activities</button>
                    <button class="page-modal-secondary-button" (click)="selected_activities = [];">Cancel</button>
                </div> -->
                <div class="activity-table-section">
					<table class="activity-table">
						<thead>
							<tr>
								<th appColumnResizable>Actions</th>
								<th appColumnResizable *ngFor="let column of activities_table_header">{{column.name}}</th>
							</tr>
						</thead>
						<tbody *ngIf="activities.length > 0">
							<ng-container *ngFor="let activity of activities; let index = index;">
								<tr [ngClass]="{'manual-task-bg': activity.activity_type != 1}">
									<td style="overflow: visible;">
										<!-- <div class="activity-checkbox-section" *ngIf="notification_item_selected != 'completed task'">
											<mat-checkbox [checked]="checkIndividualSelection(activity)"
											(change)="selectIndividual($event, activity)"></mat-checkbox>
										</div> -->
										<div class="more-details-section">
											<img src="assets/more-icon.png" class="more-details-icon" (click)="toggleActivityOptionsView(index)" />
											<div class="more-options-section" *ngIf="show_more_options == index">
												<p class="each-more-option" (click)="resetActivityData(); openEmail(activity)" *ngIf="activity.communication_type_name == 'Email'">Send Email</p>
												<p class="each-more-option" (click)="resetActivityData(); activityOpeartion(activity_data, 'Add', 'Activity Operations', index)">Add Activity</p>
												<p class="each-more-option" *ngIf="activity.activity_type != 1" (click)="resetActivityData(); activityOpeartion(activity, 'Edit', 'Activity Operations', index)">Edit Activity</p>
                                                <ng-container *ngIf="(user_role == 'Advisor' || user_role == 'AFA' || user_role == 'Relationship Manager')">
                                                    <p class="each-more-option" *ngIf="activity.afa_name == '' || activity.afa_name == null || activity.afa_name == 'Self'" (click)="resetActivityData(); openAssignActivitySection(activity, 'Reassign Activity', index)">Reassign Activity</p>
                                                    <p class="each-more-option" *ngIf="activity.afa_name != '' && activity.afa_name != null && activity.afa_name != 'Self'" (click)="resetActivityData(); unassignActivity(activity)">Unassign Activity</p>
                                                </ng-container>
												<p class="each-more-option" *ngIf="!activity.activity_paused" (click)="resetActivityData(); openAutomatedActivityOperationModal(activity, 'Individual')">Stop Activity</p>
												<p class="each-more-option" *ngIf="activity.activity_paused" (click)="resetActivityData(); openAutomatedActivityOperationModal(activity, 'Individual')">Resume Activity</p>
                                                <ng-container *ngIf="user_role == 'Assistant'">
                                                    <p class="each-more-option" *ngIf="activity.notify == false" (click)="resetActivityData(); openNotifyActivitySection(activity, 'Notify Activity', index)">Notify Activity</p>
                                                </ng-container>
												<p class="each-more-option" *ngIf="activity.activity_type != 1" (click)="resetActivityData(); removeActivity(activity)">Delete Activity</p>
												<p class="each-more-option" (click)="resetActivityData(); openCommentsSection(activity, 'Comments', index)">Comments</p>
												<p class="each-more-option" (click)="resetActivityData(); openAttachmentsSection(activity, 'Attachments', index)">Attachments</p>
												<!-- <p class="each-more-option" *ngIf="(user_role == 'Advisor') && (activity.stage == 'Pitch(Sales)' || activity.stage == 'Follow Up(Sales)')" (click)="resetActivityData(); openProductsSection(activity, 'Products', index)">Close Deal</p> -->
												<p class="each-more-option"*ngIf="((user_role == 'Advisor')  || (user_role == 'Relationship Manager') || (user_role == 'AFA' && (activity.afa_name == '' || activity.afa_name == null || activity.afa_name == 'Self'))) && (activity.activity_type == 1 || activity.activity_type == 2)" (click)="resetActivityData(); openProductsSection(activity, 'Products', index)">Close Deal</p>
												<!-- <p class="each-more-option" *ngIf="(user_role == 'Advisor') && (activity.stage == 'Pitch(Retention)' || activity.stage == 'Follow Up(Retention)')" (click)="resetActivityData(); openOutcomeSection(activity, 'Outcome', index)">Change Outcome</p> -->
												<p class="each-more-option" *ngIf="((user_role == 'Advisor')  || (user_role == 'Relationship Manager') || (user_role == 'AFA' && (activity.afa_name == '' || activity.afa_name == null || activity.afa_name == 'Self'))) && (activity.activity_type == 3 || activity.activity_type == 5)" (click)="resetActivityData(); openOutcomeSection(activity, 'Outcome', index)">Change Outcome</p>
												<p class="each-more-option" (click)="resetActivityData(); openViewHistorySection(activity, 'View History', index)">View History</p>
											</div>
										</div>
										<ng-container *ngIf="user_role != 'Advisor Manager'">
											<button class="activity-table-button" *ngIf="!activity.capture_response.captured_response" (click)="resetActivityData(); captureResponseData(activity, index, 'Capture Response')">Capture Response</button>
											<button class="activity-table-button" *ngIf="activity.capture_response.captured_response" (click)="resetActivityData(); captureResponseData(activity, index, 'Capture Response')">View/Edit Response</button>
										</ng-container>
									</td>
									<ng-container *ngFor="let column of activities_table_header" [ngSwitch]="column.key">
										<ng-container *ngSwitchCase="'name'">
											<td class="overflow-section">
												<!-- <p class="activity-name">{{activity.name}}</p> -->
												<p class="activity-name" [ngClass]="{'automated-activity-name': (activity.activity_type == 1) || (activity.activity_type == 4) || (activity.activity_type == 5)}" (click)="openActivityEmailPreviewModal(activity)">{{activity.name}}</p>
											</td>
										</ng-container>
										<ng-container *ngSwitchCase="'scheduled_date'">
											<td>
												{{activity.scheduled_date | date: "dd MMM yyyy"}}
											</td>
										</ng-container>
                                        <ng-container *ngSwitchCase="'actual_date'">
											<td>
												{{activity.actual_date | date: "dd MMM yyyy"}}
											</td>
										</ng-container>
										<ng-container *ngSwitchCase="'status_name'">
											<td [ngClass]="{ 'activity-status-pending': activity.status_name == 'Pending', 'activity-status-progress':  activity.status_name == 'In Progress', 'activity-status-completed': activity.status_name == 'Completed'}">{{activity.status_name}}</td>
										</ng-container>
										<ng-container *ngSwitchCase="'activity_type'">
											<td>
												<span *ngIf="(activity.activity_type != 1) && (activity.activity_type != 4) && (activity.activity_type != 5)" class="manual-task-status">Manual</span>
												<span *ngIf="(activity.activity_type == 1) || (activity.activity_type == 4) || (activity.activity_type == 5)">Automated</span>
											</td>
										</ng-container>
                                        <ng-container *ngSwitchCase="'lead_advisor_full_name'">
											<td>
                                                <span *ngIf="activity.lead_advisor_full_name != '' && activity.lead_advisor_full_name != null" (click)="openAssignCommentsSection('Assign Comments', index)" style="cursor: pointer;">{{activity.lead_advisor_full_name}}</span>
                                                <span *ngIf="activity.lead_advisor_full_name == '' || activity.lead_advisor_full_name == null">-</span>
                                            </td>
										</ng-container>
                                        <ng-container *ngSwitchCase="'afa_name'">
											<td>
                                                <span *ngIf="activity.afa_name != '' && activity.afa_name != null">{{activity.afa_name}}</span>
                                                <span *ngIf="activity.afa_name == '' || activity.afa_name == null">-</span>
                                            </td>
										</ng-container>
                                        <ng-container *ngSwitchCase="'notified_by'">
											<td>
                                                <span *ngIf="activity.notified_by != '' && activity.notified_by != null" (click)="openNotifyCommentsSection(activity, 'Notify Comments', index)" style="cursor: pointer;">{{activity.notified_by}}</span>
                                                <span *ngIf="activity.notified_by == '' || activity.notified_by == null">-</span>
                                            </td>
										</ng-container>
										<ng-container *ngSwitchCase="'description'">
											<td class="overflow-section" [innerHTML]="activity.description"></td>
										</ng-container>
										<ng-container *ngSwitchDefault>
											<!-- <td [matTooltip]="getKey(activity, column)">{{getKey(activity, column)}}</td> -->
											<td>{{getKey(activity, column)}}</td>
										</ng-container>
									</ng-container>
								</tr>
								<tr *ngIf="show_inner_view == index">
									<!-- <td [attr.colspan]="activities_table_header.length + 1"> -->
                                    <td colspan="7">
										<div class="activities-inner-view-section">
											<ng-container *ngIf="activity_opeartion_selected == 'Capture Response'">
												<div class="innner-heading-section">
													<!-- <span>Capture Response</span> -->
													<span>Response</span>
												</div>
												<ng-container *ngTemplateOutlet="captureResponseSection;"></ng-container>
												<div class="inner-checkbox-section">
													<mat-checkbox [(ngModel)]="show_follow_up_task">Add Follow-Up Activity</mat-checkbox>
												</div>
												<ng-container *ngIf="show_follow_up_task">
													<div class="innner-heading-section">
														<span>{{activity_operation_type}} Activity</span>
													</div>
													<ng-container *ngTemplateOutlet="activityOperationSection;"></ng-container>
												</ng-container>
                                                <ng-container *ngIf="user_role == 'Advisor' || (user_role == 'Relationship Manager') || (user_role == 'AFA' && (activity.afa_name == '' || activity.afa_name == null || activity.afa_name == 'Self'))">
                                                    <!-- <ng-container *ngIf="(activity.stage == 'Pitch(Sales)' || activity.stage == 'Follow Up(Sales)')"> -->
                                                    <ng-container *ngIf="(activity.activity_type == 1 || activity.activity_type == 2)">
                                                        <div class="inner-checkbox-section">
                                                            <mat-checkbox [(ngModel)]="show_close_deal">Close Deal</mat-checkbox>
                                                        </div>
                                                        <ng-container *ngIf="show_close_deal">
                                                            <div class="innner-heading-section">
                                                                <span>Add Product</span>
                                                            </div>
                                                            <ng-container *ngTemplateOutlet="productConversionSection;"></ng-container>
                                                        </ng-container>
                                                    </ng-container>
                                                    <!-- <ng-container *ngIf="(activity.stage == 'Pitch(Attrition)' || activity.stage == 'Follow Up(Attrition)')"> -->
                                                    <ng-container *ngIf="(activity.activity_type == 3 || activity.activity_type == 5)">
                                                        <div class="inner-checkbox-section">
                                                            <mat-checkbox [(ngModel)]="show_close_deal">Add Outcome</mat-checkbox>
                                                        </div>
                                                        <ng-container *ngIf="show_close_deal">
                                                            <div class="innner-heading-section">
                                                                <span>Add Outcome</span>
                                                            </div>
                                                            <ng-container *ngTemplateOutlet="outcomeConversionSection;"></ng-container>
                                                        </ng-container>
                                                    </ng-container>

                                                    <ng-container>
                                                        <div class="inner-checkbox-section">
                                                            <mat-checkbox [(ngModel)]="show_stage_move">Update Client Stage</mat-checkbox>
                                                        </div>
                                                        <ng-container *ngIf="show_stage_move">
                                                            <div class="innner-heading-section">
                                                                <span>Update Client Stage</span>
                                                            </div>
                                                            <ng-container *ngTemplateOutlet="clientMoveStageSection;"></ng-container>
                                                        </ng-container>
                                                    </ng-container>

                                                </ng-container>
												<div class="activities-button-section">
													<button class="page-modal-primary-button" (click)="saveCaptureResponseData(activity)">Save</button>
													<button class="page-modal-secondary-button" (click)="resetInnerViewData()">Cancel</button>
												</div>
											</ng-container>

											<ng-container *ngIf="activity_opeartion_selected == 'Activity Operations'">
												<div class="innner-heading-section">
													<span>{{activity_operation_type}} Activity</span>
												</div>
												<ng-container *ngTemplateOutlet="activityOperationSection;"></ng-container>
												<div class="activities-button-section">
													<button class="page-modal-primary-button" (click)="saveTaskData()">Save</button>
													<button class="page-modal-secondary-button" (click)="resetInnerViewData()">Cancel</button>
												</div>
											</ng-container>

                                            <ng-container *ngIf="activity_opeartion_selected == 'Reassign Activity'">
												<div class="innner-heading-section">
													<span>Reassign Activity</span>
												</div>
												<ng-container *ngTemplateOutlet="assignTaskSection;"></ng-container>
												<div class="activities-button-section">
													<button class="page-modal-primary-button" (click)="saveAssignTask()">Save</button>
													<button class="page-modal-secondary-button" (click)="resetAssignTaskData()">Cancel</button>
												</div>
											</ng-container>

                                            <ng-container *ngIf="activity_opeartion_selected == 'Assign Comments'">
												<div class="innner-heading-section">
													<span>{{activity.lead_advisor_full_name}} Commented "<strong>{{activity.lead_advisor_comments}}</strong>"</span>
												</div>
												<div class="activities-button-section">
													<button class="page-modal-secondary-button" (click)="resetAssignCommentsData()">Cancel</button>
												</div>
											</ng-container>

                                            <ng-container *ngIf="activity_opeartion_selected == 'Notify Comments'">
												<div class="innner-heading-section">
													<span>{{notify_comments_data.afa_name}} Comments</span>
												</div>
                                                <div class="activities-button-section">
													<table class="activity-table">
                                                        <thead>
                                                            <tr>
                                                                <th>Date</th>
                                                                <th>Comments</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr *ngFor=" let comment of notify_comments_data.afa_comments; let index = index">
                                                                <td>{{ comment.comment_date | date: "dd-MMM-yyyy" }}</td>
                                                                <td>{{ comment.description }}</td>
                                                            </tr>
                                                        </tbody>
													</table>
												</div>
												<div class="activities-button-section">
													<button class="page-modal-secondary-button" (click)="resetNotifyCommentsData()">Cancel</button>
												</div>
											</ng-container>

                                            <ng-container *ngIf="activity_opeartion_selected == 'Notify Activity'">
												<div class="innner-heading-section">
													<span>Notify Activity</span>
												</div>
                                                <ng-container *ngTemplateOutlet="notifyTaskSection;"></ng-container>
												<div class="activities-button-section">
                                                    <button class="page-modal-primary-button" (click)="saveNotifyTask()">Save</button>
													<button class="page-modal-secondary-button" (click)="resetNotifyTaskData()">Cancel</button>
												</div>
											</ng-container>

											<ng-container *ngIf="activity_opeartion_selected == 'Comments'">
												<div class="innner-heading-section">
													<span>Comments</span>
												</div>
												<div class="activities-button-section">
													<table class="activity-table">
														<thead>
															<tr>
																<th>Date</th>
																<th>Comments</th>
																<!-- Remove Delete <th>Action</th> -->
															</tr>
														</thead>
														<tbody>
															<tr *ngFor="let comment of comments_list;">
																<td>{{ comment.comment_date | date: "dd-MMM-yyyy" }}</td>
																<td style="overflow: hidden;" [innerHTML]="comment.description"></td>
																<!-- Remove Delete <td>
																	<img src="assets/delete-icon.png" class="activity-table-icon" (click)="deleteComment(comment)" />
																</td> -->
															</tr>
															<tr>
																<td colspan="9">
																	<span class="activity-table-icon" (click)="comment_operation_type = 'Add'">+ Add New Comment</span>
																</td>
															</tr>
														</tbody>
													</table>
												</div>
												<ng-container *ngIf="comment_operation_type != ''">
													<ng-container *ngTemplateOutlet="commentsSection;"></ng-container>
													<div class="activities-button-section">
														<button class="page-modal-primary-button" (click)="saveComment()">Save</button>
														<button class="page-modal-secondary-button" (click)="resetCommentData()">Cancel</button>
													</div>
												</ng-container>
											</ng-container>

											<ng-container *ngIf="activity_opeartion_selected == 'Attachments'">
												<div class="innner-heading-section">
													<span>Attachments</span>
												</div>
												<div class="activities-button-section">
													<table class="activity-table">
														<thead>
															<tr>
																<th>Actions</th>
																<th>Attachment Name</th>
																<th>Download Attachment</th>
																<th>Comments</th>
															</tr>
														</thead>
														<tbody>
															<ng-container *ngFor="let attachment of attachments_list;">
																<tr>
																	<td>
																		<img src="assets/edit-client.png" class="activity-table-icon" (click)="openAttachmentOperation(attachment, 'Edit', index)" />
																		<!-- Remove Delete <img src="assets/delete-icon.png" class="activity-table-icon" (click)="removeAttachment(attachment, index)" /> -->
																	</td>
																	<td style="overflow: hidden;" [matTooltip]="attachment.attachment_filename">{{attachment.attachment_filename}}</td>
																	<td>
																		<img src="assets/download-icon-blue.png" class="activity-table-icon" (click)="downloadAttachment(attachment)" />
																	</td>
																	<td style="overflow: hidden;" [matTooltip]="attachment.comments">
																		<p class="overflow-text">{{attachment.comments}}</p>
																	</td>
																</tr>
																<tr *ngIf="attachment.id == attachment_data.id">
																	<td colspan="4">
																		<ng-container>
																			<ng-container *ngTemplateOutlet="attachmentsSection;"></ng-container>
																			<div class="activities-button-section">
																				<button class="page-modal-primary-button" (click)="saveAttachment()">Save</button>
																				<button class="page-modal-secondary-button" (click)="resetAttachmentData()">Cancel</button>
																			</div>
																		</ng-container>
																	</td>
																</tr>
															</ng-container>
															<tr>
																<td colspan="4">
																	<span class="activity-table-icon" (click)=" openAttachmentOperation(attachment_data, 'Add', null)">+ Add New Attachment</span>
																</td>
															</tr>
															<tr *ngIf="attachment_operation_type != ''">
																<td colspan="4">
																	<ng-container >
																		<ng-container *ngTemplateOutlet="attachmentsSection;"></ng-container>
																		<div class="activities-button-section">
																			<button class="page-modal-primary-button" (click)="saveAttachment()">Save</button>
																			<button class="page-modal-secondary-button" (click)="resetAttachmentData()">Cancel</button>
																		</div>
																	</ng-container>
																</td>
															</tr>
														</tbody>
													</table>
												</div>
											</ng-container>

											<ng-container *ngIf="activity_opeartion_selected == 'Products'">
												<div class="innner-heading-section">
													<span>Close Deal</span>
												</div>
												<ng-container *ngTemplateOutlet="productConversionSection;"></ng-container>
												<div class="activities-button-section">
													<button class="page-modal-primary-button" (click)="addProduct()">Save</button>
													<button class="page-modal-secondary-button" (click)="resetInnerViewData()">Cancel</button>
												</div>
											</ng-container>

											<ng-container *ngIf="activity_opeartion_selected == 'Outcome'">
												<div class="innner-heading-section">
													<span>Change Outcome</span>
												</div>
												<ng-container *ngTemplateOutlet="outcomeConversionSection;"></ng-container>
												<div class="activities-button-section">
													<button class="page-modal-primary-button" (click)="addOutcome()">Save</button>
													<button class="page-modal-secondary-button" (click)="resetInnerViewData()">Cancel</button>
												</div>
											</ng-container>

                                            <ng-container *ngIf="activity_opeartion_selected == 'View History'">
												<div class="innner-heading-section">
													<span>Past Activities</span>
												</div>
                                                <div class="activities-button-section">
													<table class="activity-table">
                                                        <thead>
                                                            <tr>
                                                                <th>Date</th>
                                                                <th>Communication Channel</th>
                                                                <th>Name</th>
                                                                <th>Description</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr *ngFor=" let past_activity of activity_data.past_activities">
                                                                <td>{{ past_activity.actual_date | date: "dd-MMM-yyyy" }}</td>
                                                                <td [matTooltip]="past_activity.communication_type_name">{{ past_activity.communication_type_name }}</td>
                                                                <td [matTooltip]="past_activity.name">{{ past_activity.name }}</td>
                                                                <td [matTooltip]="past_activity.description">{{ past_activity.description }}</td>
                                                            </tr>
                                                        </tbody>
													</table>
												</div>
												<div class="activities-button-section">
													<button class="page-modal-secondary-button" (click)="resetViewHistorySection()">Cancel</button>
												</div>
											</ng-container>

										</div>
									</td>
								</tr>
							</ng-container>
						</tbody>
						<tbody *ngIf="activities.length == 0">
							<tr>
								<td [attr.colspan]="activities_table_header.length + 1">
                                <!-- <td colspan="8"> -->
									<div style="text-align: center">
										<span>No Activities Found</span>
									</div>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
            </ng-container>
            <ng-container *ngIf="activities_loader">
                <app-loader [loading_text]="'Loading Automatic Activities'"></app-loader>
            </ng-container>
        </div>
    </div>
</ng-template>

<ng-template #captureResponseSection>
    <div class="capture-response-section">
        <div class="page-input-section">
            <p class="page-input-label">Response Status</p>
            <mat-select class="page-input" [(ngModel)]="capture_response_data.response_status">
                <mat-option [value]="''">Select Response Status</mat-option>
                <mat-option [value]="'Interested'">Interested</mat-option>
                <mat-option [value]="'Not Interested'">Not Interested</mat-option>
                <mat-option [value]="'No Contact'">No Contact</mat-option>
            </mat-select>
            <p class="page-input-error" *ngIf="capture_response_data_errors.response_status">Response Status is Required.</p>
        </div>
        <div class="page-input-section page-input-small">
            <p class="page-input-label">Response Channel</p>
            <mat-select class="page-input" [(ngModel)]="capture_response_data.response_channel">
                <mat-option [value]="''">Select Response Channel</mat-option>
                <mat-option *ngFor="let communication_type of communication_type_list" [value]="communication_type.id">{{communication_type.name}}</mat-option>
            </mat-select>
            <p class="page-input-error" *ngIf="capture_response_data_errors.response_channel">Response Channel is Required.</p>
        </div>
        <div class="page-input-section page-input-small">
            <p class="page-input-label">Response Date</p>
            <input
                type="text"
                class="page-input"
                bsDatepicker
                placement="left"
                [(ngModel)]="capture_response_data.response_capture_date"
                [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
            />
            <p class="page-input-error" *ngIf="capture_response_data_errors.response_capture_date">Response Date is Required.</p>
        </div>
        <div class="page-input-section page-input-large">
            <p class="page-input-label">Response Comments</p>
            <textarea class="page-input page-textarea" [(ngModel)]="capture_response_data.response_comments"></textarea>
            <p class="page-input-error" *ngIf="capture_response_data_errors.response_comments">Response Comments is Required.</p>
        </div>
    </div>
</ng-template>

<ng-template #activityOperationSection>
    <div class="capture-response-section">
        <div class="page-input-section">
            <p class="page-input-label">Activity Name</p>
            <!-- <input type="text" class="page-input" [(ngModel)]="activity_data.name" /> -->
            <mat-select class="page-input" [(ngModel)]="activity_data.name">
                <mat-option [value]="''">Select Activity Name</mat-option>
                <mat-option *ngFor="let task_name of task_names_list" [value]="task_name.name">{{task_name.name}}</mat-option>
            </mat-select>
            <p class="page-input-error" *ngIf="activity_data_errors.name">Activity Name is Required.</p>
        </div>
        <div class="page-input-section page-input-small">
            <p class="page-input-label">Scheduled Date</p>
            <input
                type="text"
                class="page-input"
                bsDatepicker
                placement="left"
                [(ngModel)]="activity_data.scheduled_date"
                [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
            />
            <p class="page-input-error" *ngIf="activity_data_errors.scheduled_date">Scheduled Date is Required.</p>
        </div>
        <div class="page-input-section page-input-small">
            <p class="page-input-label">Actual Date</p>
            <input
                type="text"
                class="page-input"
                bsDatepicker
                placement="left"
                [(ngModel)]="activity_data.actual_date"
                [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
            />
            <p class="page-input-error" *ngIf="activity_data_errors.actual_date">Actual Date is Required.</p>
        </div>
        <div class="page-input-section page-input-large">
            <p class="page-input-label">Description</p>
            <!-- <textarea class="page-input page-textarea" [(ngModel)]="activity_data.description"></textarea> -->
            <app-textarea-tagging [value]="activity_data.description" [users]="tagging_users_list" [placeholder]="'Description ...'" (valueChanged)="activity_data.description = $event"></app-textarea-tagging>
            <p class="page-input-error" *ngIf="activity_data_errors.description">Description is Required.</p>
        </div>
        <div class="page-input-section">
            <p class="page-input-label">Communication Channel</p>
            <mat-select class="page-input" [(ngModel)]="activity_data.communication_type">
                <mat-option [value]="''">Select Communication Channel</mat-option>
                <mat-option *ngFor="let communication of communication_type_list" [value]="communication.id">{{ communication.name }}</mat-option>
            </mat-select>
            <p class="page-input-error" *ngIf="activity_data_errors.communication_type">Communication Channel is Required.</p>
        </div>
        <!-- <div class="page-input-section page-input-small"> -->
		<div class="page-input-section">
            <p class="page-input-label">Status</p>
            <mat-select class="page-input" [(ngModel)]="activity_data.status">
                <mat-option [value]="''">Select Status</mat-option>
                <mat-option *ngFor="let status of status_list" [value]="status.id">{{status.name}}</mat-option>
            </mat-select>
            <p class="page-input-error" *ngIf="activity_data_errors.status">Status is Required.</p>
        </div>
        <!-- <div class="page-input-section page-input-small">
            <p class="page-input-label">Assign</p>
            <mat-select class="page-input" [(ngModel)]="activity_data.afa_id">
                <mat-option [value]="''">Self</mat-option>
                <mat-option *ngFor="let afa of afa_list" [value]="afa.id">{{ afa.first_name }} {{ afa.last_name }}</mat-option>
            </mat-select>
            <p class="page-input-error" *ngIf="activity_data_errors.afa_id">Assign is Required.</p>
        </div>
        <div class="page-input-section page-input-large">
            <p class="page-input-label">Assign Comments</p>
            <textarea class="page-input page-textarea" [(ngModel)]="activity_data.afa_comments"></textarea>
            <p class="page-input-error" *ngIf="activity_data_errors.afa_comments">Assign Comments is Required.</p>
        </div> -->
    </div>
</ng-template>

<ng-template #manualActivityOperationSection>
    <div class="capture-response-section">
        <div class="page-input-section">
            <p class="page-input-label">Activity Name</p>
            <!-- <input type="text" class="page-input" [(ngModel)]="manual_activity_data.name" /> -->
            <mat-select class="page-input" [(ngModel)]="manual_activity_data.name">
                <mat-option [value]="''">Select Activity Name</mat-option>
                <mat-option *ngFor="let task_name of task_names_list" [value]="task_name.name">{{task_name.name}}</mat-option>
            </mat-select>
            <p class="page-input-error" *ngIf="manual_activity_data_errors.name">Activity Name is Required.</p>
        </div>
        <div class="page-input-section page-input-small">
            <p class="page-input-label">Scheduled Date</p>
            <input
                type="text"
                class="page-input"
                bsDatepicker
                placement="left"
                [(ngModel)]="manual_activity_data.scheduled_date"
                [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
            />
            <p class="page-input-error" *ngIf="manual_activity_data_errors.scheduled_date">Scheduled Date is Required.</p>
        </div>
        <div class="page-input-section page-input-small">
            <p class="page-input-label">Actual Date</p>
            <input
                type="text"
                class="page-input"
                bsDatepicker
                placement="left"
                [(ngModel)]="manual_activity_data.actual_date"
                [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
            />
            <p class="page-input-error" *ngIf="manual_activity_data_errors.actual_date">Actual Date is Required.</p>
        </div>
        <div class="page-input-section page-input-large">
            <p class="page-input-label">Description</p>
            <!-- <textarea class="page-input page-textarea" [(ngModel)]="manual_activity_data.description"></textarea> -->
            <app-textarea-tagging [value]="manual_activity_data.description" [users]="tagging_users_list" [placeholder]="'Description ...'" (valueChanged)="manual_activity_data.description = $event"></app-textarea-tagging>
            <p class="page-input-error" *ngIf="manual_activity_data_errors.description">Description is Required.</p>
        </div>
        <div class="page-input-section">
            <p class="page-input-label">Communication Channel</p>
            <mat-select class="page-input" [(ngModel)]="manual_activity_data.communication_type">
                <mat-option [value]="''">Select Communication Channel</mat-option>
                <mat-option *ngFor="let communication of communication_type_list" [value]="communication.id">{{ communication.name }}</mat-option>
            </mat-select>
            <p class="page-input-error" *ngIf="manual_activity_data_errors.communication_type">Communication Channel is Required.</p>
        </div>
        <div class="page-input-section page-input-small">
            <p class="page-input-label">Status</p>
            <mat-select class="page-input" [(ngModel)]="manual_activity_data.status">
                <mat-option [value]="''">Select Status</mat-option>
                <mat-option *ngFor="let status of status_list" [value]="status.id">{{status.name}}</mat-option>
            </mat-select>
            <p class="page-input-error" *ngIf="manual_activity_data_errors.status">Status is Required.</p>
        </div>
        <div class="page-input-section page-input-small">
            <p class="page-input-label">Assign</p>
            <mat-select class="page-input" [(ngModel)]="manual_activity_data.afa_id">
                <mat-option [value]="''">Self</mat-option>
                <mat-option *ngFor="let afa of afa_list" [value]="afa.id">{{ afa.first_name }} {{ afa.last_name }}</mat-option>
            </mat-select>
            <p class="page-input-error" *ngIf="manual_activity_data_errors.afa_id">Assign is Required.</p>
        </div>
        <div class="page-input-section page-input-large">
            <p class="page-input-label">Assign Comments</p>
            <textarea class="page-input page-textarea" [(ngModel)]="manual_activity_data.afa_comments"></textarea>
            <p class="page-input-error" *ngIf="manual_activity_data_errors.afa_comments">Assign Comments is Required.</p>
        </div>
    </div>
</ng-template>

<ng-template #assignTaskSection>
    <div class="capture-response-section">
        <div class="page-input-section">
            <p class="page-input-label">Assignee</p>
            <mat-select class="page-input" [(ngModel)]="assign_task_data.afa">
                <mat-option [value]="''">Select Assignee</mat-option>
                <mat-option *ngFor="let afa of afa_list" [value]="afa.id">{{ afa.first_name }} {{ afa.last_name }}</mat-option>
            </mat-select>
            <p class="page-input-error" *ngIf="assign_task_data_errors.afa">Assignee is Required.</p>
        </div>
        <div class="page-input-section page-input-small">
            <p class="page-input-label">Initial Target Date</p>
            <input
                type="text"
                class="page-input"
                bsDatepicker
                placement="left"
                [(ngModel)]="activity_data.scheduled_date"
                [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
                [disabled]="true"
            />
        </div>
        <div class="page-input-section page-input-small">
            <p class="page-input-label">Revised Target Date</p>
            <input
                type="text"
                class="page-input"
                bsDatepicker
                placement="left"
                [(ngModel)]="assign_task_data.target_date"
                [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
            />
            <p class="page-input-error" *ngIf="assign_task_data_errors.target_date">Revised Target Date is Required.</p>
        </div>
        <div class="page-input-section page-input-large">
            <p class="page-input-label">Comments</p>
            <textarea class="page-input page-textarea" [(ngModel)]="assign_task_data.afa_comments"></textarea>
            <p class="page-input-error" *ngIf="assign_task_data_errors.afa_comments">Assign Comments is Required.</p>
        </div>
    </div>
</ng-template>

<ng-template #notifyTaskSection>
    <div class="capture-response-section">
        <div class="page-input-section page-input-large">
            <p class="page-input-label">Comments</p>
            <textarea class="page-input page-textarea" [(ngModel)]="notify_advisor_comments"></textarea>
            <p class="page-input-error" *ngIf="notify_advisor_comments_error">Comments is Required.</p>
        </div>
    </div>
</ng-template>

<ng-template #commentsSection>
    <div class="capture-response-section">
        <div class="page-input-section">
            <p class="page-input-label">Date</p>
            <input
                type="text"
                class="page-input"
                bsDatepicker
                placement="right"
                [(ngModel)]="comment_data.comment_date"
                [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
            />
            <p class="page-input-error" *ngIf="comment_data_errors.comment_date">Date is Required.</p>
        </div>
        <div class="page-input-section page-input-large">
            <p class="page-input-label">Comments</p>
            <textarea class="page-input page-textarea" [(ngModel)]="comment_data.description"></textarea>
            <p class="page-input-error" *ngIf="comment_data_errors.description">Comments is Required.</p>
        </div>
    </div>
</ng-template>

<ng-template #attachmentsSection>
    <div class="capture-response-section">
        <div class="page-input-section">
            <!-- <p class="page-input-label">Upload Attachment</p> -->
            <input type="file" #file_upload style="display: none;" (change)="uploadAttachment($event)" />
            <button class="page-modal-primary-button" (click)="file_upload.click()">Upload Attachment</button>
            <span>{{attachment_data.attachment_filename}}</span>
            <p class="page-input-error" *ngIf="attachment_data_errors.attachment_filename">Attachment is Required.</p>
        </div>
        <div class="page-input-section page-input-large">
            <p class="page-input-label">Comments</p>
            <textarea class="page-input page-textarea" [(ngModel)]="attachment_data.comments"></textarea>
            <p class="page-input-error" *ngIf="attachment_data_errors.comments">Comments is Required.</p>
        </div>
    </div>
</ng-template>

<ng-template #productsSection>
    <div class="automated-activities-section">
        <div class="automated-activities-header-section">
            <div class="automated-activities-heading-section">
                <img src="assets/automated-activities.png" class="automated-activities-heading-icon" />
                <span>Products</span>
            </div>
        </div>
        <div class="automated-activities-content-section">
            <ng-container *ngIf="!products_list_loader">
                <table class="activity-table">
                    <thead>
                        <tr>
                            <th appColumnResizable>
                                <span *ngIf="user_role != 'Relationship Manager'">Policy Number</span>
                                <span *ngIf="user_role == 'Relationship Manager'">Deposit Number</span>
                            </th>
                            <th appColumnResizable>Product</th>
                            <th appColumnResizable>AUM</th>
                            <th appColumnResizable *ngIf="user_role == 'Relationship Manager'">Purpose</th>
                            <th appColumnResizable>Activated Date</th>
                            <th appColumnResizable>Status</th>
                            <th appColumnResizable style="text-align: center;">Actions</th>
                        </tr>
                    </thead>
                    <tbody *ngIf="products_list.length > 0">
                        <ng-container *ngFor="let product of products_list; let index = index;">
                            <tr>
                                <td>{{product.policy_number}}</td>
                                <td>{{product.product_name}}</td>
                                <td>{{product.amount}}</td>
                                <td *ngIf="user_role == 'Relationship Manager'">{{product.deposit_purpose}}</td>
                                <td>
                                    {{product.start_date | date: "dd MMM yyyy"}}
                                </td>
                                <td>
                                    <span [ngClass]="{'activity-status-pending': product.client_product_status_name == 'In Active', 'activity-status-progress': product.client_product_status_name == 'Active', 'activity-status-completed': product.client_product_status_name == 'Completed'}">{{ product.client_product_status_name }}</span>
                                </td>
                                <td style="text-align: center;">
                                    <div class="more-details-section">
                                        <img src="assets/more-icon.png" class="more-details-icon" (click)="toggleActivityOptionsView(index)" />
                                        <div class="more-options-section" *ngIf="show_more_options == index">
                                            <p class="each-more-option" (click)="productOpeartion(product, 'Edit', index)">Edit Product</p>
                                            <p class="each-more-option" (click)="removeProduct(product)">Delete Product</p>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr *ngIf="show_inner_view == index">
                                <td colspan="6">
                                    <div class="activities-inner-view-section">
                                        <div class="innner-heading-section">
                                            <span>Edit Product</span>
                                        </div>
                                        <ng-container *ngTemplateOutlet="productOperationSection;"></ng-container>
                                        <div class="activities-button-section">
                                            <button class="page-modal-primary-button" (click)="updateProduct()">Save</button>
                                            <button class="page-modal-secondary-button" (click)="resetInnerViewData()">Cancel</button>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </ng-container>
                    </tbody>
                    <tbody *ngIf="products_list.length == 0">
                        <tr>
                            <td colspan="6">
                                <div style="text-align: center">
                                    <span>No Products Found</span>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </ng-container>
            <ng-container *ngIf="products_list_loader">
                <app-loader [loading_text]="'Loading Client Products'"></app-loader>
            </ng-container>
        </div>
    </div>
</ng-template>

<ng-template #productConversionSection>
    <div class="capture-response-section">
        <div class="page-input-section">
            <p class="page-input-label">Conversion Status</p>
            <mat-select class="page-input" [(ngModel)]="conversion_status_data.conversion_status" >
                <mat-option [value]="''">Select Conversion Status</mat-option>
                <mat-option *ngFor="let conversion_status of conversion_status_list" [value]="conversion_status.id" (click)=" conversion_status_data.conversion_status_name = conversion_status.name ">{{ conversion_status.name }}</mat-option>
            </mat-select>
            <p class="page-input-error" *ngIf="conversion_status_data_errors.conversion_status">Conversion Status is Required.</p>
        </div>
        <div class="page-input-section page-input-large">
            <p class="page-input-label">Comments</p>
            <textarea class="page-input page-textarea" [(ngModel)]="conversion_status_data.conversion_comments"></textarea>
            <p class="page-input-error" *ngIf="conversion_status_data_errors.conversion_comments">Comments is Required.</p>
        </div>
        <ng-container *ngIf="conversion_status_data.conversion_status == 1">
            <ng-container *ngTemplateOutlet="productOperationSection;"></ng-container>
        </ng-container>
    </div>
</ng-template>

<ng-template #productOperationSection>
    <div class="page-input-section">
        <p class="page-input-label" *ngIf="user_role != 'Relationship Manager'">Policy Number</p>
        <p class="page-input-label" *ngIf="user_role == 'Relationship Manager'">Deposit Number</p>
        <input type="text" class="page-input" [(ngModel)]="product_data.policy_number" />
        <p class="page-input-error" *ngIf="product_data_errors.policy_number">
            <span *ngIf="user_role != 'Relationship Manager'">Policy Number</span>
            <span *ngIf="user_role == 'Relationship Manager'">Deposit Number</span>
             is Required.
        </p>
    </div>
    <div class="page-input-section">
        <p class="page-input-label">AUM</p>
        <input type="text" class="page-input" [(ngModel)]="product_data.aum" (keypress)="numberOnly($event)" />
        <p class="page-input-error" *ngIf="product_data_errors.aum">AUM is Required.</p>
    </div>
    <div class="page-input-section">
        <p class="page-input-label">Product</p>
        <mat-select class="page-input" [(ngModel)]="product_data.product">
            <mat-option [value]="''">Select Product</mat-option>
            <mat-option *ngFor="let product of product_list" [value]="product.id" (click)="getProductType(product_data.product)" >{{ product.name }}</mat-option>
        </mat-select>
        <p class="page-input-error" *ngIf="product_data_errors.product">Product is Required.</p>
    </div>
    <div class="page-input-section page-input-small">
        <p class="page-input-label">Activated Date</p>
        <input
            type="text"
            class="page-input"
            bsDatepicker
            placement="left"
            [(ngModel)]="product_data.start_date"
            [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
        />
        <p class="page-input-error" *ngIf="product_data_errors.start_date">Activated Date is Required.</p>
    </div>
    <div class="page-input-section page-input-small" *ngIf="getProductType(product_data.product)">
        <p class="page-input-label">Valid Until *</p>
        <input
            type="text"
            class="page-input"
            bsDatepicker
            placement="left"
            [(ngModel)]="product_data.close_date"
            [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
        />
        <p class="page-input-error" *ngIf="product_data_errors.close_date">Valid Until is Required.</p>
    </div>
    <div class="page-input-section" *ngIf="user_role == 'Relationship Manager'">
        <p class="page-input-label">Purpose</p>
        <mat-select class="page-input" [(ngModel)]="product_data.deposit_purpose">
            <mat-option [value]="''">Select Purpose</mat-option>
            <mat-option [value]="'Emergency Fund'">Emergency Fund</mat-option>
            <mat-option [value]="'Short-Term Goals'">Short-Term Goals</mat-option>
            <mat-option [value]="'Long-Term Savings'">Long-Term Savings</mat-option>
            <mat-option [value]="'Education Expenses'">Education Expenses</mat-option>
            <mat-option [value]="'Retirement Savings'">Retirement Savings</mat-option>
            <mat-option [value]="'Building Wealth'">Building Wealth</mat-option>
            <mat-option [value]="'Income Generation'">Income Generation</mat-option>
            <mat-option [value]="'Estate Planning'">Estate Planning</mat-option>
            <mat-option [value]="'Tax Payments'">Tax Payments</mat-option>
            <mat-option [value]="'Business Operations'">Business Operations</mat-option>
        </mat-select>
        <p class="page-input-error" *ngIf="product_data_errors.deposit_purpose">Purpose is Required.</p>
    </div>
    <div class="page-input-section">
        <p class="page-input-label">Type</p>
        <mat-select class="page-input" [(ngModel)]="product_data.type">
            <mat-option [value]="''">Select Type</mat-option>
            <!-- <mat-option [value]="'New Acquisition'">New Acquisition</mat-option>
            <mat-option [value]="'Cross-Sell'">Cross-Sell</mat-option>
            <mat-option [value]="'Up-Sell'">Up-Sell</mat-option> -->
            <mat-option [value]="'New Acquisition'">New Acquisition</mat-option>
            <mat-option [value]="'Upside'">Upside</mat-option>
            <mat-option [value]="'Retention'">Retention</mat-option>
        </mat-select>
        <p class="page-input-error" *ngIf="product_data_errors.type">Type is Required.</p>
    </div>
    <div class="page-input-section">
        <p class="page-input-label">Client Product Status</p>
        <mat-select class="page-input" [(ngModel)]="product_data.client_product_status">
            <mat-option [value]="''">Select Product Status</mat-option>
            <mat-option *ngFor="let status of client_product_status_list" [value]="status.id">{{status.name}}</mat-option>
        </mat-select>
        <p class="page-input-error" *ngIf="product_data_errors.client_product_status"> Client Product Status is Required.</p>
    </div>
</ng-template>

<ng-template #automatedActivitiesOperationModal>
    <div class="modal-section">
        <div class="modal-heading-section client-view-heading-section">
            <span class="modal-heading">Activity Operation</span>
            <span class="client-modal-icon" (click)="closeAutomatedActivityOperationModal()">&times;</span>
        </div>
        <div class="modal-content-section">
            <p class="page-modal-delete-description" *ngIf="automated_activities_operation_type != 'Individual'">
                Do you want to stop the
                <span *ngIf="selected_activities.length != 1">activities</span>
                <span *ngIf="selected_activities.length == 1">activity</span>
            </p>
            <p class="page-modal-delete-description" *ngIf="automated_activities_operation_type == 'Individual'">
                Do you want to
                <span *ngIf="selected_activities[0].activity_paused">resume</span>
                <span *ngIf="!selected_activities[0].activity_paused">stop</span> the activity
            </p>
        </div>
        <div class="modal-footer-section">
            <button class="page-modal-primary-button" (click)="automatedActivityOperation()">Yes</button>
            <button class="page-modal-secondary-button" (click)="closeAutomatedActivityOperationModal()">No</button>
        </div>
    </div>
</ng-template>

<ng-template #activitiesDeleteModal>
    <div class="modal-section">
        <div class="modal-heading-section client-view-heading-section">
            <span class="modal-heading">Delete Activity</span>
            <span class="client-modal-icon" (click)="closeDeleteActivityModal()">&times;</span>
        </div>
        <div class="modal-content-section">
            <p class="page-modal-delete-description">Are you sure you want to delete?</p>
        </div>
        <div class="modal-footer-section">
            <button class="page-modal-primary-button" (click)="deleteActivity()">Yes</button>
            <button class="page-modal-secondary-button" (click)="closeDeleteActivityModal()">No</button>
        </div>
    </div>
</ng-template>

<ng-template #attachmentDeleteModal>
    <div class="modal-section">
        <div class="modal-heading-section client-view-heading-section">
            <span class="modal-heading">Delete Attachment Details</span>
            <span class="client-modal-icon" (click)="closeDeleteAttachmentModal()">&times;</span>
        </div>
        <div class="modal-content-section">
            <p class="page-modal-delete-description">Are you sure you want to delete?</p>
        </div>
        <div class="modal-footer-section">
            <button class="page-modal-primary-button" (click)="deleteAttachment()">Yes</button>
            <button class="page-modal-secondary-button" (click)="closeDeleteAttachmentModal()">No</button>
        </div>
    </div>
</ng-template>

<ng-template #productDeleteModal>
    <div class="modal-section">
        <div class="modal-heading-section client-view-heading-section">
            <span class="modal-heading">Delete Product</span>
            <span class="client-modal-icon" (click)="closeDeleteProductModal()">&times;</span>
        </div>
        <div class="modal-content-section">
            <p class="page-modal-delete-description">Are you sure you want to delete?</p>
        </div>
        <div class="modal-footer-section">
            <button class="page-modal-primary-button" (click)="deleteProduct()">Yes</button>
            <button class="page-modal-secondary-button" (click)="closeDeleteProductModal()">No</button>
        </div>
    </div>
</ng-template>

<ng-template #outcomeConversionSection>
    <div class="capture-response-section">
        <div class="page-input-section">
            <p class="page-input-label">Outcome Status</p>
            <mat-select class="page-input" [(ngModel)]="outcome_data.attrition_status" >
                <mat-option [value]="''">Select Outcome Status</mat-option>
                <mat-option [value]="'Retained'">Retained</mat-option>
                <mat-option [value]="'Retained, Upside'">Retained, Upside</mat-option>
                <mat-option [value]="'Likely to Switch Advisor'">Likely to Switch Advisor</mat-option>
            </mat-select>
            <p class="page-input-error" *ngIf="outcome_data_errors.attrition_status">Outcome Status is Required.</p>
        </div>
        <div class="page-input-section page-input-large">
            <p class="page-input-label">Comments</p>
            <textarea class="page-input page-textarea" [(ngModel)]="outcome_data.attrition_comments"></textarea>
            <p class="page-input-error" *ngIf="outcome_data_errors.attrition_comments">Comments is Required.</p>
        </div>
        <ng-container *ngIf="outcome_data.attrition_status == 'Retained, Upside'">
            <ng-container *ngTemplateOutlet="productOperationSection;"></ng-container>
        </ng-container>
    </div>
</ng-template>

<ng-template #clientMoveStageSection>
    <div class="capture-response-section">
        <div class="page-input-section">
            <p class="page-input-label">Select Stage</p>
            <mat-select class="page-input" [(ngModel)]="move_stage_data.stage" >
                <mat-option [value]="''">Select Stage</mat-option>
                <mat-option *ngFor="let stage of move_stages_list" [value]="stage.id">{{ stage.name }}</mat-option>
            </mat-select>
            <p class="page-input-error" *ngIf="move_stage_data_errors.stage">Stage is Required.</p>
        </div>
        <div>
            <div class="page-input-section">
                <mat-checkbox [(ngModel)]="move_stage_data.activity_status">Mark Stage Activities as Not Required</mat-checkbox>
            </div>
        </div>
    </div>
</ng-template>



<ng-template #activityEmailPreviewModal>
    <div class="page-modal-section">
        <div class="page-modal-heading-section">
            <span>{{ activity_email_data.template_name }}</span>
            <span class="page-modal-close-icon" (click)="closeActivityEmailPreviewModal()">&times;</span>
        </div>
        <div class="page-modal-content-section" *ngIf="activity_email_data_loaded">
            <div class="page-modal-input-section">
                <p class="page-modal-input-label">Subject: {{ activity_email_data.subject }}</p>
            </div>
            <div class="page-modal-input-section">
                <p class="page-modal-input-label">Email Body:</p>
                <p class="page-modal-input-label" [innerHTML]="getHTML(activity_email_data.email_body)">{{ activity_email_data.template_name }}</p>
            </div>
            <div class="page-modal-input-section" *ngIf=" activity_email_data.greetings_image != '' && activity_email_data.greetings_image != null ">
                <button class="page-modal-primary-button" (click)="download(activity_email_data.greetings_image)" >Download Attachment</button>
            </div>
        </div>
        <div class="page-modal-content-section" *ngIf="!activity_email_data_loaded">
            <app-loader [loading_text]="'Loading'"></app-loader>
        </div>
        <div class="page-modal-footer-section">
            <button class="page-modal-secondary-button" (click)="closeActivityEmailPreviewModal()">Cancel</button>
        </div>
    </div>
  </ng-template>
